<template>
  <bootstrap-toast v-show="show">
    <template slot="title">
      <i class="fas fa-cookie"></i>
      <strong class="mr-auto">Nós usamos cookies</strong>
    </template>

    <p>Nossa plataforma usa cookies para fornecer uma melhor experiência e um melhor desempenho. Para mais informações sobre como usamos cookies e as escolhas que você tem em relação ao controle de cookies, leia nossa <a :href="urlPoliticaPrivacidade" target="_blank">Política de Privacidade</a>.</p>
    <p>Ao continuar a usar o serviço, você concorda com o uso de cookies, conforme descrito na <a :href="urlPoliticaPrivacidade" target="_blank">Política de Privacidade</a>.</p>
    <div class="text-center">
      <a href="javascript:void(0)" @click="acceptCookies()" class="btn btn-secondary" data-dismiss="toast" aria-label="Close">Ok</a>
    </div>
  </bootstrap-toast>
</template>

<script>
import BootstrapToast from '../../../core/components/BootstrapToast'

export default {
  name: 'InfoCookieToast',
  components: { BootstrapToast },
  data () {
    return {
      show: localStorage.getItem('acceptCookies') ? !localStorage.getItem('acceptCookies') : true
    }
  },

  computed: {
    urlPoliticaPrivacidade: function () {
      return `${process.env.VUE_APP_BASE_FILES_URL}documentos/Poli%CC%81tica+de+Privacidade+Jaleko_fev2020Geral_final.pdf`
    }
  },

  methods: {
    acceptCookies: function () {
      localStorage.setItem('acceptCookies', true)
      this.show = false
    }
  }
}
</script>

<style scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>
